import React from 'react';
import { getCastellerShortName } from '../../../utils/castellerName';

const getName = (casteller) => {
    return getCastellerShortName(casteller, '');
};

function CopilotGhostText({ casteller }) {
    if (!casteller) return null;

    const name = getName(casteller);
    const altura = casteller.altura;

    return (
        <div className="copilot-ghost" aria-hidden="true">
            <span className="copilot-ghost-name">{name}</span>
            {altura !== null && altura !== '' && !isNaN(altura) && <span className="copilot-ghost-altura">{altura}</span>}
        </div>
    );
}

export default CopilotGhostText;
